export function normalizeString(input: string): string {
  return input.trim().replace(/\s+/g, ' ').toLowerCase();
}
